import PropTypes from 'prop-types';
import React from 'react';

import {AccreditationButton} from '../AccreditationButton';
import {RequiredItems} from '../RequiredItems/RequiredItems';

const Information = '/icons/information.png';
import './InformationAboutDocuments.style.scss';

export const InformationAboutDocuments = (props) => {
  return (
    <div className="information-documents" id="documentos">
      <div className="information-documents__background" />
      <div className="information-documents__content">
        <h2 className="information-documents__title">
          Já vai separando alguns documentos!
        </h2>
        <p className="information-documents__text">
          O processo de credenciamento demora uns 15 minutinhos e você vai
          precisar ter em mãos os seguintes documentos:
        </p>
      </div>
      <div className="information-documents__image">
        <img src={Information} alt="Imagem de animação" />
      </div>
      <RequiredItems />
      <div className="accreditation-button-box">
        <div className="accreditation-button-box__content">
          <AccreditationButton
            {...props}
            elementType="box:button:click"
            elementContent="none:quero-me-credenciar:documentos"
          />
        </div>
      </div>
    </div>
  );
};

InformationAboutDocuments.propTypes = {
  buttonFunctionShowBanks: PropTypes.func,
  buttonFunctionShowAccreditation: PropTypes.func
};
